import { Container, SectionText } from '@/atoms';
import { SwiperCustom } from '@/molecules';
import PressCard from '@/organisms/press-card';

import type { TypePressCardProps } from '@/organisms/press-card';
import type { FunctionComponent } from 'react';
import type { TypePressTemplateProps } from './types';

/**
 * PressTemplate
 */
export const PressTemplate: FunctionComponent<TypePressTemplateProps> = ({
  className = '',
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  caption,
  cards,
  cutLevel = 50,
  cutLevelMobile = 50,
  textColor,
  title,
  index,
  id,
}: TypePressTemplateProps) => (
  <Container
    index={index}
    backgroundColorBottom={backgroundColorBottom}
    backgroundColorTopMobile={backgroundColorTopMobile}
    backgroundColorTop={backgroundColorTop}
    backgroundColorBottomMobile={backgroundColorBottomMobile}
    cutLevel={cutLevel === null ? 50 : cutLevel}
    cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
    overflows
    className={`ml-5 flex flex-col gap-10 lg:flex-row lg:gap-20 ${className}`}
    id={id}
  >
    <div
      className={`w-full ${
        cutLevelMobile === null ? 'max-w-[33%]' : 'max-w-fit'
      }`}
    >
      <SectionText
        caption={caption}
        title={title}
        direction="column"
        textAlign="start"
        variant={textColor}
      />
    </div>
    <SwiperCustom
      gap={20}
      slidesPerView={3}
      slidesPerViewMobile={1.4}
      navigation
      scrollbar
      className="w-full lg:max-w-[45%]"
      slideGrow={true}
    >
      {cards.map((card: TypePressCardProps, index: number) => (
        <PressCard key={index} {...card} className="h-full" />
      ))}
    </SwiperCustom>
  </Container>
);

PressTemplate.displayName = 'PressTemplate';
